import { makeStyles, Theme, createStyles, useMediaQuery } from "@material-ui/core";
import React, { Fragment } from "react";
import { observer } from "mobx-react";
import { AccountMultiplePlus, AccountPlus, Email } from "mdi-material-ui";
import clsx from "clsx";
import TableToolbar from "../../../../Shared/Table/TableToolbar";
import { VolunteerFilterOptionCollections } from "./VolunteersFilterPopper";
import VolunteersOverflowMenu from "./VolunteersOverflowMenu";
import REMButton from "../../../../../shared/modules/rem-conversion/components/Button";
import VolunteerSearchAndFilterToolbar from "./VolunteerSearchAndFilterToolbar";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        actionButton: {
            color: theme.palette.action.active
        },
        rightMargin: {
            marginRight: theme.spacing(1)
        },
        leftMargin: {
            marginLeft: theme.spacing(1)
        },
        noWrap: {
            textWrap: 'nowrap'
        }
    }),
);

interface VolunteersOverviewMainMenuProps extends VolunteerFilterOptionCollections {
    searchQuery?: string;
    onSearchInputChanged: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    onEmailsClicked: () => void;
    onImportClicked: () => void;
    onNewVolunteerClicked: () => void;
}

const VolunteersOverviewMainMenu = observer((props: VolunteersOverviewMainMenuProps) => {

    const classes = useStyles();

    const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

    /********* Render *********/

    return (
        <TableToolbar
            leftButtons={
                <VolunteerSearchAndFilterToolbar
                    searchQuery={props.searchQuery}
                    onSearchInputChanged={props.onSearchInputChanged}
                    roleOptions={props.roleOptions}
                    statusOptions={props.statusOptions}
                />
            }
            rightButtons={
                mdDown
                    ? <Fragment>
                        <VolunteersOverflowMenu
                            onEmailsClicked={props.onEmailsClicked}
                            onImportClicked={props.onImportClicked}
                        />
                        <REMButton
                            startIcon={<AccountPlus />}
                            color="primary"
                            variant="contained"
                            size="large"
                            onClick={props.onNewVolunteerClicked}
                        >
                            Add
                        </REMButton>
                    </Fragment>
                    : <Fragment>
                        <REMButton
                            startIcon={<Email />}
                            variant="outlined"
                            size="large"
                            onClick={props.onEmailsClicked}
                            className={clsx(classes.actionButton, classes.rightMargin, classes.leftMargin)}
                        >
                            Emails
                        </REMButton>
                        <REMButton
                            startIcon={<AccountMultiplePlus />}
                            variant="outlined"
                            size="large"
                            onClick={props.onImportClicked}
                            className={clsx(classes.actionButton, classes.rightMargin)}
                        >
                            Import
                        </REMButton>
                        <REMButton
                            startIcon={<AccountPlus />}
                            color="primary"
                            variant="contained"
                            size="large"
                            onClick={props.onNewVolunteerClicked}
                            className={classes.noWrap}
                        >
                            New Volunteer
                        </REMButton>
                    </Fragment>
            }
        />
    );
});

export default VolunteersOverviewMainMenu;